import * as React from "react";

import { useTopMessages } from "../providers";

export const TopMessages: React.FunctionComponent = () => {
  const { topMessage, handleCloseTopMessage } = useTopMessages();

  if (!topMessage) {
    return null;
  }
  return (
    <div className="top-messages">
      <div className="top-message-box">
        <div className="decoration left" />
        <div className="content">
          <p className="message">{topMessage}</p>
          <button
            className="close-top-message"
            onClick={handleCloseTopMessage}
          />
        </div>
      </div>
    </div>
  );
};
